export enum FailedServices {
    TaskGrid = 'TASK_GRID',
    NotificationLog = 'NOTIFICATION_LOG',
    ActivityFeed = 'ACTIVITY_FEED',
    ActivityFeedCount = 'ACTIVITY_FEED_COUNT',
    ExternalTask = 'EXTERNAL_TASK',
    CoverageInbox = 'COVERAGE_INBOX',
    SMSInbox = 'SMS_INBOX'
}